export interface AuthorizedResource {
  effect?: string | null;
  code: string;
  actions?: string[];
  description?: string | null;
}

export type AuthorizedResourceAccessMap = Record<string, boolean>;

export const isAuthorizedResourceAllowed = (effect?: string | null) =>
  effect === 'ALLOW';

export function buildAuthorizedResourceAccessMap(
  authorizedResources: AuthorizedResource[] = [],
): AuthorizedResourceAccessMap {
  return authorizedResources.reduce<AuthorizedResourceAccessMap>(
    (accumulator, resource) => {
      if (!resource?.code) {
        return accumulator;
      }

      const allowed = isAuthorizedResourceAllowed(resource.effect);

      accumulator[resource.code] = allowed;

      (resource.actions ?? []).forEach((action) => {
        if (!action) {
          return;
        }

        accumulator[`${resource.code}:${action}`] = allowed;
      });

      return accumulator;
    },
    {},
  );
}
